module.exports = __webpack_public_path__ + "4b7b7f5f.webp";